import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { LookupWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  COLUMN_SOURCE_ID,
  DATASET_SOURCE_ID,
  EXPAND_SOURCE_ID,
  VALUE_SOURCE_ID,
  WorkflowError,
} from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';
import { validateDataset } from '../_validations/dataset';

@WorkflowNode('Lookup')
export class LookupNode extends BaseWorkflowNode<LookupWorkflowNode> {
  static readonly EXPAND_SOURCE_ID = EXPAND_SOURCE_ID;
  static readonly COLUMN_SOURCE_ID = COLUMN_SOURCE_ID;
  static readonly VALUE_SOURCE_ID = VALUE_SOURCE_ID;
  static readonly DATASET_SOURCE_ID = DATASET_SOURCE_ID;
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.linkColumn, schemas, LookupNode.EXPAND_SOURCE_ID),
      ...getColumnReferencesFromString(
        this.node.joinCondition.column,
        schemas,
        LookupNode.COLUMN_SOURCE_ID,
      ),
      ...getColumnReferencesFromString(
        this.node.joinCondition.value,
        schemas,
        LookupNode.VALUE_SOURCE_ID,
      ),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.linkColumn, schemas, LookupNode.EXPAND_SOURCE_ID),
      ...getTagReferencesFromString(
        this.node.joinCondition.column,
        schemas,
        LookupNode.COLUMN_SOURCE_ID,
      ),
      ...getTagReferencesFromString(
        this.node.joinCondition.value,
        schemas,
        LookupNode.VALUE_SOURCE_ID,
      ),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(
        this.node.linkColumn,
        schemas,
        connectors,
        LookupNode.EXPAND_SOURCE_ID,
      ),
      ...getParamReferencesFromString(
        this.node.joinCondition.column,
        schemas,
        connectors,
        LookupNode.COLUMN_SOURCE_ID,
      ),
      ...getParamReferencesFromString(
        this.node.joinCondition.value,
        schemas,
        connectors,
        LookupNode.VALUE_SOURCE_ID,
      ),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(
        this.node.linkColumn,
        schemas,
        LookupNode.EXPAND_SOURCE_ID,
      ),
      ...getNamedInputReferencesFromString(
        this.node.joinCondition.column,
        schemas,
        LookupNode.COLUMN_SOURCE_ID,
      ),
      ...getNamedInputReferencesFromString(
        this.node.joinCondition.value,
        schemas,
        LookupNode.VALUE_SOURCE_ID,
      ),
    ];
  }

  override validate(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowError<any>[] {
    const errors = super.validate(schemas, connectors);

    return [
      ...errors,
      ...validateDataset(this.workflowId, this.nodeId, this.node.datasetId, schemas),
    ];
  }
}
